import type { VoidFunctionComponent } from 'react';

import { icons, IconText, TooltipBadge } from '../../../../generic';

const MAX_LENGTH = 50;
export const OriginOrganizationNameBadge: VoidFunctionComponent<{
  originOrganizationName: string | null,
}> = ({ originOrganizationName }) => {
  if (!originOrganizationName) {
    return null;
  }

  let truncatedName = originOrganizationName;
  if (truncatedName.length > MAX_LENGTH) {
    truncatedName = `${truncatedName.substring(0, MAX_LENGTH)}...`;
  }

  return (
    <TooltipBadge
      id="origin-organization-name"
      tooltip={<IconText icon={icons.circleInfo} text={originOrganizationName} />}
      color="light-gray"
      size="micro"
    >
      {truncatedName}
    </TooltipBadge>
  );
};
